export enum StepOperationType {
    LOAD = 'load',
    UNLOAD = 'unload',
    RETURN = 'return',
    REEVALUATE_TRIP = 'reevaluate_trip',
    NON_SPECIFIED = 'non_specified',
}
